// @flow
import React from 'react';
import './LoadingPlaceholder.less';

type Props = {
    extraClasses: string
};

const LoadingPlaceholder = ({extraClasses}: Props) => {
    return (
        <div className={`LoadingPlaceholder ${extraClasses}`}>
            <div className="LoadingPlaceholder__inner" />
        </div>
    );
};

export default LoadingPlaceholder;
